import EditorialCrossNavigation from '@design-system/components/Editorial/EditorialCrossNavigation.vue'
import EditorialMarqueeStrip from '@design-system/components/Editorial/EditorialMarqueeStrip.vue'
import EditorialContent from '@design-system/components/Editorial/EditorialContent.vue'
import EditorialGridModule from '@design-system/components/Editorial/EditorialGridModule.vue'
import EditorialValues from '@design-system/components/Editorial/EditorialValues.vue'
import EditorialCategoriesLaunch from '@design-system/components/Editorial/EditorialCategoriesLaunch.vue'
import EditorialSocialWall from '@design-system/components/Editorial/EditorialSocialWall.vue'
import EditorialDiscover from '@design-system/components/Editorial/EditorialDiscover.vue'
import EditorialGallerySlideshow from '@design-system/components/Editorial/EditorialGallerySlideshow.vue'
import EditorialTextModule from '@design-system/components/Editorial/EditorialTextModule.vue'
import EditorialProductCard from '@design-system/components/Editorial/EditorialProductCard.vue'
import EditorialSocialStrip from '@design-system/components/Editorial/EditorialSocialStrip.vue'
import EditorialIrregular from '@design-system/components/Editorial/EditorialIrregular.vue'
import EditorialProductHero from '@design-system/components/Editorial/EditorialProductHero.vue'
import EditorialCarouselProductsWithChips from '@design-system/components/Editorial/EditorialCarouselProductsWithChips.vue'
import EditorialLookGrid from '@design-system/components/Editorial/EditorialLookGrid.vue'
import EditorialGalleryHover from '@design-system/components/Editorial/EditorialGalleryHover.vue'
import EditorialFashionShow from '@design-system/components/Editorial/FashionShow/EditorialFashionShow.vue'
import EditorialDiscoverAlternative from '@design-system/components/Editorial/EditorialDiscoverAlternative.vue'
import EditorialStripAnchors from '@design-system/components/Editorial/StripAnchors/EditorialStripAnchors.vue'

export const editorialModulesMapping: Record<string, Component> = {
  'https://armani.com/cross-navigation': EditorialCrossNavigation,
  'https://armani.com/strip-layout': EditorialMarqueeStrip,
  'https://armani.com/grid-module': EditorialGridModule,
  'https://armani.com/hero-banner': EditorialContent,
  'https://armani.com/values-editorial': EditorialValues,
  'https://armani.com/launching-categories': EditorialCategoriesLaunch,
  'https://armani.com/editorial-social-wall': EditorialSocialWall,
  'https://armani.com/editorial-discover': EditorialDiscover,
  'https://armani.com/editorial-slide-show-gallery-new':
    EditorialGallerySlideshow,
  'https://armani.com/editorial-text-module': EditorialTextModule,
  'https://armani.com/product-tiles': EditorialProductCard,
  'https://armani.com/editorial-social-strip': EditorialSocialStrip,
  'https://armani.com/editorial-irregular': EditorialIrregular,
  'https://armani.com/editorial-product-hero': EditorialProductHero,
  'https://armani.com/editorial-carousel-product-with-chips':
    EditorialCarouselProductsWithChips,
  'https://armani.com/editorial-gallery-hover': EditorialGalleryHover,
  'https://armani.com/editorial-grid-fashion-show-gallery': EditorialLookGrid,
  'https://armani.com/editorial-fashion-show': EditorialFashionShow,
  'https://armani.com/editorial-discover-alternative':
    EditorialDiscoverAlternative,
  'https://armani.com/editorial-strip-anchors': EditorialStripAnchors,
}
